import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Input, Label, Button, Badge, Card, CardHeader, CardBody, Table } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/kgbService"

import DataTableBloc from '../Blocs/DataTableBloc'
import IndexBloc from "../Blocs/IndexBloc"
import apiResponse from '../../../../../services/apiResponse'
import { withRouter } from "react-router"
import SKModal from "./SKModal";
import SKCollectiveModal from "./SKCollectiveModal"

import moment from 'moment'

class TableSecondaryComponent extends Component {
	dataTableBloc = new DataTableBloc();
	indexBloc = new IndexBloc();

	source
	historyTable = 'KGBEmpTableSecondary'
	defaultOrder = 'kgb_temp_pangkat'
	defaultSize = 10
	defaultSort = 'desc'
	configDatatable = {
		...config('datatable'),
		sort: {
			column: this.defaultOrder,
			order: this.defaultSort
		}
	}

	modal_confirm_status = 0
	modal_confirm_message = ""
	modal_confirm_sucess_message = "data berhasil diproses"
	modal_confirm_error_message = "data gagal diproses"

	constructor(props) {
		super(props)
		this.state = {
			tooltip: false,
			draftSkUuid: null,
			uploadSkUuid: null,
			detailUuid: null,
			updateUuid: null,
			inactiveUuid: null,
			defaultSize: 10,
			rows: [],
			totalRow: 0,
			loadingTable: true,
			filter: sessionStorage.getItem(this.historyTable) ?
				JSON.parse(sessionStorage.getItem(this.historyTable)) :
				{
					filter_value: "",
					page_number: 1,
					page_size: this.defaultSize,
					sort_order: {
						column: this.defaultOrder,
						order: this.defaultSort
					}
				},
			dataSelected: [],
			checkAll: false,
			modalSKC: false,
			period : this.props.period
		}
		console.log(this.props.period)
	}

	toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

	toggle = () => {
		this.setState({ modal: !this.state.modal })
	}

	toggleModalSKC = () => {
		this.setState({ modalSKC: !this.state.modalSKC })
	}

	dateParse = (input) => {
		let res = "-";
		if (input != "" && input != null) {
			res = moment(input).format('DD/MM/YYYY')
		}
		return res;
	}

	rupiah = (num) => {
		let res = "-";
		if (num != null && num != '') {
			res = parseFloat(num).toLocaleString('id-ID', { maximumFractionDigits: 2 })
		}
		return res;
	}

	handleChecked = (e, uuid) => {
		var checked = e.target.checked;
		if (checked) {
			this.setState({
				dataSelected: [
					...this.state.dataSelected,
					uuid
				]
			})
		} else {
			var filteredAry = this.state.dataSelected.filter(e => e !== uuid)
			this.setState({
				dataSelected: filteredAry
			})
		}
		console.log(this.props.period)
	}

	handleCheckAll = (e) => {
		let checked = e.target.checked;
		let uuidSelected = [];
		let idx = 0;
		for (let i = 0; i < this.state.rows.length; i++) {
			let thisId = this.state.rows[i].kgb_temp_id
			let thisUuid = this.state.rows[i].kgb_temp_uuid

			if (this.state.rows[i].kgb_temp_collective_decree_uuid == null) {
				this.setState({
					[`check${thisId}`]: !this.state.checkAll,
				})
				if (checked == true) {
					uuidSelected[idx] = thisUuid;
				}
				idx++;
			}
		}

		this.setState({
			checkAll: !this.state.checkAll,
			dataSelected: uuidSelected
		})
	}

	handleButtonProcess = () => {
		console.log(this.state.dataSelected)
	}

	handleDownloadDraftSK = (uuid) => {
		this.indexBloc.fetchDownloadDraftSK({
			kgb_temp_uuid: uuid
		});
	}

	fetchListSKCollective = () => {
		
		this.indexBloc.fetchListSKC({ period_uuid: this.props.uuid })
	}

	loadData = async () => {
		/* history Datatable */
		sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

		/* kirim ke server */
		let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
		if (this.state.defaultSize !== this.state.filter.page_size) {
			this.setState({
				defaultSize: this.state.filter.page_size
			})
			offset = 0
			this.configDatatable.page_number = 1
		}
		const query = {
			search: this.state.filter.filter_value,
			limit: this.state.filter.page_size,
			offset: offset,
			order: this.state.filter.sort_order.column,
			sort: this.state.filter.sort_order.order,
			status: 1,
			period_uuid: this.props.uuid,
			is_process: 1
		}
		await this.dataTableBloc.fetchRowTable(query, this.source.token)
	}

	setTokenAPI = () => {
		if (typeof this.source != typeof undefined) {
			this.source.cancel();
		}
		this.source = cancelToken()
		this.loadData()
	}

	inactiveData = async () => {
		await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
	}

	confirmResponse = (response) => {
		let forState = {}
		switch (response) {
			case 'cancel':
				forState = {
					confirm: false
				}
				break;
			case 'confirm':
				forState = {
					loading: true,
					confirm: false
				}
				this.inactiveData()
				break;
			case 'delete':
				forState = {
					loading: true,
					confirm: false
				}
				this.inactiveData()
				break;
			case 'success':
				forState = {
					success: false,
					redirect: true
				}
				break;
			case 'failed':
				forState = {
					failed: false
				}
				break;
			default:
		}
		console.log(response)
		this.setState(forState)
	}

	componentDidMount() {
		this.setTokenAPI()

		this.dataTableBloc.rowtableChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.INITIAL:
					this.setState({
						loadingTable: false
					})
					break
				case apiResponse.LOADING:
					this.setState({
						loadingTable: true
					})
					break
				case apiResponse.COMPLETED:
					const response = result.data.response

					// set state for every checkbox
					for (let i = 0; i < response.result.length; i++) {
						let thisId = response.result[i].kgb_temp_id
						this.setState({
							[`check${thisId}`]: false
						})
					}
					this.setState({
						totalRow: response.total,
						rows: response.result,
						loadingTable: false
					})
					break
				case apiResponse.ERROR:

					break
				default:
					break
			}
		})

		this.indexBloc.downloadDraftSKChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.LOADING:
					this.setState({
						loading: true,
					})
					break
				case apiResponse.COMPLETED:
					const link = result.data.response
					window.open(link.file_url, "_blank")
					//window.location.href = link.file_url
					this.setState({
						loading: false,
						success: true
					})
					setTimeout(() => {
						this.setState({
							success: false,
						})
					}, 1000);
					break
				case apiResponse.ERROR:
					this.setState({
						urlFileDetail: link,
						loading: false,
						failed: true
					})
					setTimeout(function () {
						this.setState({
							failed: false,
						})
					}, 1000)
					break
				default:
					break
			}
		})

		this.indexBloc.listSKCChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					if (result.data.status) {
						let response = result.data.response
						this.setState({
							skc_list: response.result,
						})
					}
					break
				case apiResponse.ERROR:

					break
				default:
					break
			}
		})
		this.dataTableBloc.inactiveChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
						loadingTable: true
					}, function () {
						this.setTokenAPI()
						//this.props.handleInactiveSuccess()
					});
					break
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
					});
					break
				default:
					break
			}
		})

		this.fetchListSKCollective()

		this.indexBloc.downloadSKCChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.LOADING:
					this.setState({
						loading: true,
					})
					break
				case apiResponse.COMPLETED:
					const link = result.data.response
					window.open(link.file_url, "_blank")
					//window.location.href = link.file_url
					this.setState({
						loading: false,
						success: true
					})
					setTimeout(() => {
						this.setState({
							success: false,
						})
					}, 1000);
					break
				case apiResponse.ERROR:
					this.setState({
						urlFileDetail: link,
						loading: false,
						failed: true
					})
					setTimeout(function () {
						this.setState({
							failed: false,
						})
					}, 1000)
					break
				default:
					break
			}
		})

	}

	componentWillUnmount() {
		this.dataTableBloc.rowtableChannel.unsubscribe()
		this.indexBloc.downloadDraftSKChannel.unsubscribe()
		this.indexBloc.exportLampiranChannel.unsubscribe()
	}

	columns = [
		{
			key: "kgb_temp_id",
			text: "Pilih",
			className: "kgb_temp_id",
			sortable: false,
			header: () => {
				return (
					<div className="form-check text-center font-size-16">
						<Input
							className="form-check-input"
							type="checkbox"
							name="checkAll"
							value=""
							checked={this.state.checkAll}
							onChange={(event) => {
								this.handleCheckAll(event)
							}}
						/>
					</div>
				)
			},
			cell: record => {
				const thisId = record.kgb_temp_id
				return (
					record.kgb_temp_collective_decree_uuid == null ?
						<div className="form-check text-center font-size-16">
							<Input
								type="checkbox"
								className="form-check-input"
								id={'checkbox' + thisId}
								onChange={
									(event) => {
										this.handleChecked(event, record.kgb_temp_uuid);
										this.setState({
											[`check${thisId}`]: !this.state[`check${thisId}`]
										})
									}
								}
								checked={this.state[`check${thisId}`]}
							/>
						</div>
						: ""
				)
			}
		},
		{
			key: "employee_full_name",
			text: "Pegawai",
			className: "employee_full_name",
			sortable: true,
			cell: record => {
				return (
					<>
						<b>{record.kgb_temp_employee_name}</b>
						<div>{record.kgb_temp_employee_nip}</div>
						<div>{record.kgb_temp_tempat_lahir}, {this.dateParse(record.kgb_temp_tanggal_lahir)}</div>
					</>
				)
			}
		},
		{
			key: "kgb_temp_golongan_ruang",
			text: "Golongan/Ruang",
			className: "kgb_temp_golongan_ruang",
			sortable: true,
		},
		{
			key: "kgb_temp_sk_lama",
			text: "SK Lama",
			className: "kgb_temp_sk_lama",
			sortable: true,
			cell: record => {
				return (
					<>
						<b>{record.kgb_temp_sk_lama}</b>
						<div>{this.dateParse(record.kgb_temp_tanggal_sk_lama)}</div>
					</>
				)
			}
		},
		{
			key: "kgb_temp_masa_kerja_tahun_lama",
			text: "Masa Kerja Lama",
			className: "kgb_temp_masa_kerja_tahun_lama",
			sortable: true,
			cell: record => {
				return (
					<>
						<b>{record.kgb_temp_masa_kerja_tahun_lama} Tahun</b>
						<div>{record.kgb_temp_masa_kerja_bulan_lama} Bulan</div>
					</>
				)
			}
		},
		{
			key: "kgb_temp_gaji_pokok_lama",
			text: "Gaji Lama",
			className: "kgb_temp_gaji_pokok_lama",
			sortable: true,
			cell: record => {
				return this.rupiah(record.kgb_temp_gaji_pokok_lama);
			}
		},
		{
			key: "kgb_temp_tmt_lama",
			text: "TMT Lama",
			className: "kgb_temp_tmt_lama",
			sortable: true,
			cell: record => {
				return this.dateParse(record.kgb_temp_tmt_lama);
			}
		},
		{
			key: "kgb_temp_masa_kerja_tahun",
			text: "Masa Kerja Baru",
			className: "kgb_temp_masa_kerja_tahun",
			sortable: true,
			cell: record => {
				return (
					<>
						<b>{record.kgb_temp_masa_kerja_tahun} Tahun</b>
						<div>{record.kgb_temp_masa_kerja_bulan} Bulan</div>
					</>
				)
			}
		},
		{
			key: "kgb_temp_gaji_pokok_baru",
			text: "Gaji Baru",
			className: "kgb_temp_gaji_pokok_baru",
			sortable: true,
			cell: record => {
				return this.rupiah(record.kgb_temp_gaji_pokok_baru);
			}
		},
		{
			key: "kgb_temp_sk_baru",
			text: "Nomor SK",
			className: "kgb_temp_sk_baru",
			sortable: true,
		},
		{
			key: "kgb_temp_status",
			text: "Status",
			className: "kgb_temp_status",
			sortable: true,
			width: '100',
			cell: record => {
				let status = parseInt(record.kgb_temp_status);
				if (status == -1) {
					status = (
						<label className="badge rounded-pill bg-soft-info font-size-12">
							Rekomendasi
						</label>
					);
				} else if (status == 0) {
					status = (
						<label className="badge rounded-pill bg-soft-warning font-size-12">
							Menunggu Proses
						</label>
					);
				} else if (status == 1) {
					status = (
						<label className="badge rounded-pill bg-soft-success font-size-12">
							Selesai
						</label>
					);
				} else if (status == 2) {
					status = (
						<label className="badge rounded-pill bg-soft-error font-size-12">
							Ditolak
						</label>
					);
				}
				return <span> {status} </span>;
			}
		},
		{
			key: "action",
			text: "Action",
			className: "action",
			width: 120,
			sortable: false,
			align: 'center',
			cell: record => {
				const thisId = record.kgb_temp_id
				const status = record.kgb_temp_status
				return (
					<Fragment>
						{
							status == 0 && record.kgb_temp_sk_baru == null ?
								<span>
									<button
										className="btn btn-primary btn-sm"
										id={"inputSk-" + thisId}
										onClick={() => {
											this.setState({ inputSKUuid: record.kgb_temp_uuid })
											this.toggle()
										}}
										style={{
											marginRight: '2px',
											padding: '2px 5px'
										}}>
										<i className="uil-pen"></i>
									</button>
									<Tooltip
										style={{
											marginBottom: 2
										}}
										placement="top" isOpen={this.state["inputSk" + thisId]} target={"inputSk-" + thisId}
										toggle={() => {
											this.setState({
												["inputSk" + thisId]: !this.state["inputSk" + thisId]
											})
										}}
									>Input SK</Tooltip>
								</span>
								: ""
						}

						{
							status == 0 && record.kgb_temp_sk_baru != null ?
								<span>
									<button
										className="btn btn-info btn-sm"
										id={"draftSk-" + thisId}
										onClick={() => {
											this.handleDownloadDraftSK(record.kgb_temp_uuid)
										}}
										style={{
											marginRight: '2px',
											padding: '2px 5px'
										}}>
										<i className="uil-file-download-alt"></i>
									</button>
									<Tooltip
										style={{
											marginBottom: 2
										}}
										placement="top" isOpen={this.state["draftSk" + thisId]} target={"draftSk-" + thisId}
										toggle={() => {
											this.setState({
												["draftSk" + thisId]: !this.state["draftSk" + thisId]
											})
										}}
									>Download Draft SK</Tooltip>
								</span>
								: ""
						}

						{
							status == 0 && record.kgb_temp_sk_baru != null ?
								<span>
									<button
										className="btn btn-warning btn-sm"
										id={"uploadSk-" + thisId}
										onClick={() => {
											this.setState({
												uploadSkUuid: record.kgb_temp_uuid
											})
										}}
										style={{
											marginRight: '2px',
											padding: '2px 5px'
										}}>
										<i className="uil-file-upload-alt"></i>
									</button>
									<Tooltip
										style={{
											marginBottom: 2
										}}
										placement="top" isOpen={this.state["uploadSk" + thisId]} target={"uploadSk-" + thisId}
										toggle={() => {
											this.setState({
												["uploadSk" + thisId]: !this.state["uploadSk" + thisId]
											})
										}}
									>Verifikasi & Upload SK</Tooltip>
								</span>
								: ""
						}
						{accessRole('delete') && status == 0 ?
							<span>
								<button
									className="btn btn-danger btn-sm"
									type="button"
									id={"delete-" + thisId}
									onClick={() => {
										this.setState({
											inactiveUuid: record.kgb_temp_uuid,
											confirm: true
										})
									}}
									style={{
										padding: '2px 5px'
									}}>
									<i className="uil-trash-alt"></i>
								</button>
								<Tooltip
									style={{
										marginBottom: 2
									}}
									placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
									toggle={() => {
										this.setState({
											["delete" + thisId]: !this.state["delete" + thisId]
										})
									}}
								>Hapus</Tooltip>
							</span>
							: ""
						}

					</Fragment>
				);
			}
		}
	]

	render() {
		return (
			<>

				<div className="">
					<b className="me-2">
						Data Terpilih : <Badge className="rounded-pill bg-success font-size-12"> {this.state.dataSelected.length} </Badge> dari total <Badge className="rounded-pill bg-warning font-size-12"> {this.state.totalRow} </Badge>
					</b>

					<Button
						className="me-2"
						color="primary"
						onClick={
							() => {
								this.toggleModalSKC()
							}
						}
						disabled={this.state.dataSelected.length > 0 ? false : true}
					>Buat SK Kolektif</Button>
				</div>

				<hr />

				<Card outline color="primary" className="border">
					<CardHeader className="bg-transparent">
						<h5 className="my-0 text-primary">
							SK Kolektif
						</h5>
					</CardHeader>
					<CardBody>
						<div className="table-responsive">
							<Table className="table-bordered table-striped">
								<thead>
									<tr>
										<th>No</th>
										<th>Nomor SK</th>
										<th>Tanggal SK</th>
										<th>Jumlah Pegawai</th>
										<th>Download</th>
									</tr>
								</thead>
								<tbody>
									{
										this.state.skc_list?.length > 0 ?
											this.state.skc_list?.map((val, i) => {
												return (
													<tr>
														<td>{++i}</td>
														<td>{val.kgb_collective_decree_number}</td>
														<td>{this.dateParse(val.kgb_collective_decree_date)}</td>
														<td>{val.employee_total}</td>
														<td>
															<button
																className="btn btn-info btn-sm"
																id={"draftSkC-" + val.kgb_collective_decree_id}
																onClick={() => {
																	console.log()
																	//this.handleDownloadDraftSK(val.kgb_temp_collective_decree_uuid)
																	this.indexBloc.fetchDownloadSKC({
																		uuid: val.kgb_collective_decree_uuid
																	});
																}}
																style={{
																	marginRight: '2px',
																	padding: '2px 5px'
																}}>
																<i className="uil-file-download-alt"></i>
															</button>
														</td>
													</tr>
												)
											})
											:
											<tr>
												<td colSpan="5" className="text-center">Tidak Ada SK Kolektif</td>
											</tr>
									}
								</tbody>
							</Table>
						</div>
					</CardBody>
				</Card>

				<hr />
				<MKIDatatable
					className={this.configDatatable.tableClass}
					config={this.configDatatable}
					records={this.state.rows}
					columns={this.columns}
					dynamic={true}
					minWidth={1000}
					total_record={this.state.totalRow}
					initial={this.state.filter}
					onChange={(filter) => {
						this.setState({
							loadingTable: true,
							filter: filter
						}, function () {
							this.setTokenAPI()
						});
					}}
					loading={this.state.loadingTable}
				/>
				<ConfirmAlert
					confirmTitle="Konfirmasi!"
					confirmInfo={this.modal_confirm_message}

					loadingTitle="Memproses data..."
					loadingInfo="Tunggu beberapa saat"

					successTitle="Berhasil!"
					successInfo={this.modal_confirm_sucess_message}

					failedTitle="Gagal!"
					failedInfo={this.modal_confirm_error_message}

					showConfirm={this.state.confirm}
					showLoading={this.state.loading}
					showSuccess={this.state.success}
					showFailed={this.state.failed}

					response={this.confirmResponse}
				/>
				<ConfirmAlert
					confirmTitle="Konfirmasi!"
					confirmInfo="Apakah anda yakin akan menghapus data ini?"
					loadingTitle="Mengirim data..."
					loadingInfo="Tunggu beberapa saat"
					successTitle="Berhasil!"
					successInfo="Data berhasil dihapus"
					failedTitle="Gagal!"
					failedInfo="Data gagal dihapus"
					showConfirm={this.state.confirm}
					showLoading={this.state.loading}
					showSuccess={this.state.success}
					showFailed={this.state.failed}
					response={this.confirmResponse}
				/>
				<SKModal
					modal={this.state.modal}
					toggle={() => this.toggle()}
					// periodUuid={this.state.period?.cpns_period_uuid} 
					// uuid={this.state.uuid} 
					// setUuid={value => this.setUuid(value)} 
					handleReload={() => this.setTokenAPI()}
					uuid={this.state.inputSKUuid}
				/>

				<SKCollectiveModal
					modal={this.state.modalSKC}
					toggle={() => this.toggleModalSKC()}
					periodUuid={this.props.uuid}
					uuids={this.state.dataSelected}
					period = {this.props.period}
					// uuid={this.state.uuid} 
					// setUuid={value => this.setUuid(value)} 
					handleReload={() => { this.setTokenAPI(); this.fetchListSKCollective(); }}
					uuid={this.state.inputSKUuid}
					selectedCount={this.state.dataSelected.length}
				/>

				{this.state.uploadSkUuid !== null ?
					<Redirect to={"/kepegawaian/kgb.html?upload_sk&uuid=" + this.state.uploadSkUuid + "&period_uuid=" + this.props.uuid} />
					: null}
				{this.state.detailUuid !== null ?
					<Redirect to={"/kepegawaian/kgb.html?detail&uuid=" + this.state.detailUuid + "&period_uuid=" + this.props.uuid} />
					: null}
			</>
		)
	}

}

export default TableSecondaryComponent